<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('tuition_assistance_re_evaluation_request')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('tuition_assistance_re_evaluation_request')"
                              :isFilter="false"/>
            </template>
            <div class="row data-form">
                <div class="col-12">
                    <div class="mb-4">
                        <h6 class="text-uppercase mb-0">{{ $t('information').toUpper() }}</h6>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('student_id')">{{ studentFormData.student_number}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('name')">{{ studentFormData.name}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('surname')">{{studentFormData.surname}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('cgpa')">{{studentFormData.cgpa}}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('prior_rate')">{{studentFormData.tuition_per_credit}}</b-form-group>
                </div>
            </div>
            <hr>
            <div class="my-3 d-inline-block"></div>
            <div class="mb-4">
                <h6 class="text-uppercase mb-0">{{ $t('application_information').toUpper() }}</h6>
            </div>
            <ValidationObserver ref="studentForm">
                <label class="col-form-label">{{ $t('upload_your_documents') }}</label>
                <b-row>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="file1" rules="required" v-slot="{ valid, errors }">
                            <b-form-group>
                                <div class="d-flex custom-file-upload">
                                    <b-form-file
                                        v-model="formData.file1"
                                        accept=".pdf,.doc,.docx"
                                        :state="errors.length ? false : valid ? true : null"
                                        :placeholder="$t('select_file')"
                                        :drop-placeholder="$t('drop_file')"
                                        ref="fileInput1"
                                    />
                                    <b-button
                                        variant="outline-secondary"
                                        @click="$refs.fileInput1.$refs.input.click();"
                                    >
                                        {{ $t('browse') }}
                                    </b-button>
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="file2" rules="required" v-slot="{ valid, errors }">
                            <b-form-group>
                                <div class="d-flex custom-file-upload">
                                    <b-form-file
                                        v-model="formData.file2"
                                        accept=".pdf,.doc,.docx"
                                        :state="errors.length ? false : valid ? true : null"
                                        :placeholder="$t('select_file')"
                                        :drop-placeholder="$t('drop_file')"
                                        ref="fileInput2"
                                    />
                                    <b-button
                                        variant="outline-secondary"
                                        @click="$refs.fileInput2.$refs.input.click();"
                                    >
                                        {{ $t('browse') }}
                                    </b-button>
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </ValidationObserver>
            <div class="d-flex justify-content-center">
                <b-form-group>
                    <b-button variant="primary" @click="save">{{ $t('submit') }}</b-button>
                </b-form-group>
            </div>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout';
import Header from '@/layouts/AppLayout/Header';
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import StudentProgramService from "@/services/StudentProgramService";
import TuitionAssistanceService from "@/services/TuitionAssistanceService";
import ConstantService from "@/services/ConstantService";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            formData: {
                file1: null,
                file2: null,
            },
            studentFormData: {},
            user: {},
            studentProgramId: null,
        }
    },
    metaInfo() {
        return {
            title: this.$t('tuition_assistance_re_evaluation_request')
        }
    },
    async mounted() {
        this.user = this.$store.getters['auth/getUser'];
        this.studentProgramId = this.user.active_student_program.id;
        await this.getFormData(this.studentProgramId)
    },
    methods: {
        async getFormData(id) {
            try {
                const response = await StudentProgramService.get(id)
                this.studentFormData = response.data.data
            }catch (error) {
                this.showErrors(error)
            }
        },
        async save(){
            if (!await this.$refs.studentForm.validate()) return

            const formData = new FormData();
            if (this.formData.file1) formData.append('files[]', this.formData.file1);
            if (this.formData.file2) formData.append('files[]', this.formData.file2);

            TuitionAssistanceService.store(formData)
                .then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$router.push('/tuition/assistance/requests/0')
                })
                .catch(e => {
                    this.showErrors(e, this.$refs.studentForm);
                })

        }
    },
};
</script>
